import { Component, OnInit, Inject } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { Messages } from '../../constants/messages';
import { ValidationService } from 'src/app/validation.service';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';


export interface EditVehicleType {
  registrationNumber?: string;
  type?: string;
  registrationYear?: number;
  chassisNumber?: string;
  engineNumber?: number;
  mileage?: number;
  mileageUnit?: string;
  tankCapacity?: number;
  tankCapacityUnit?: string;
  vehiclePic?: File;
  gps_id?: string;
  gps_provider?: string;
  actual_capacity?: number;
}

@Component({
  selector: 'app-edit-vehicle',
  templateUrl: './edit-vehicle.component.html',
  styleUrls: ['./edit-vehicle.component.scss']
})
export class EditVehicleComponent implements OnInit {

  file: File;
  vehicleData: EditVehicleType = {
  };

  type;
  formData = new FormData();

  gps_providers = [];
  ksa_gps_providers = [
    // {
    //   name: 'Mix',
    //   value: 'MIX'
    // },
    // {
    //   name: 'Max Media',
    //   value: 'MAX_MEDIA'
    // }
  ];
  in_gps_providers = [
    // { name: 'None',value: '' },
    // { name: 'Rivigo',value: 'rivigo' },
    // { name: 'Sahaj',value: 'sahaj' },
    // { name: 'Om Logistics',value: 'omlog' },
    // { name: 'e-Trans',value: 'etrans' },
    // { name: 'InGen',value: 'ingen' }
  ];
  asset;
  assets;
  selectedAsset;
  assetsArray;
  selectedGPSProvider;
  showGPSProvider = false;
  originalData;
  messages = new Messages();
  d = new Date();
  minYear: any;
  vehicletypes;
  vehicle_pattern;
  spinner = false;

  showVerifyLinks = false;


  constructor(private dialog: MatDialogRef<EditVehicleComponent>,
              private http: HttpService, private snackbar: SnackbarService,
              private validData: ValidationService, @Inject(MAT_DIALOG_DATA) private parentData: any,private translation:TranslateService) { 
                if (environment.country == 'SA') {
                  this.showGPSProvider = true;
                }
              }

  ngOnInit() {
    this.showVerifyLinks = environment.country === 'IN';
    this.getGPSProviders()
    this.vehicle_pattern = environment.vehicle_pattern;
    this.getVehicleTypes();
    if (this.parentData.vehicleNumber) {

      this.vehicleData.registrationNumber = this.parentData.vehicleNumber;
    }
    if (this.parentData.vehicle.type) {

      this.vehicleData.type = this.parentData.vehicle.type;
    }
    if (this.parentData.registration.chassis_number) {

      this.vehicleData.chassisNumber = this.parentData.registration.chassis_number;
    }
    if (this.parentData.registration.engine_number) {

      this.vehicleData.engineNumber = this.parentData.registration.engine_number;
    }
    if (this.parentData.tank.mileage) {

      this.vehicleData.mileage = this.parentData.tank.mileage;
    }
    if (this.parentData.tank.capacity) {

      this.vehicleData.tankCapacity = this.parentData.tank.capacity ;
    }
    if (this.parentData.tank.capacity_unit) {

      this.vehicleData.tankCapacityUnit = this.parentData.tank.capacity_unit;
    }
    if (this.parentData.tank.mileage_unit) {

      this.vehicleData.mileageUnit = this.parentData.tank.mileage_unit;
    }
    if (this.parentData.registration.year) {

      this.vehicleData.registrationYear = this.parentData.registration.year;
    }
    if (this.parentData) {
      this.vehicleData.actual_capacity = this.parentData.capacity ? this.parentData.capacity : this.parentData.vehicle.capacity;
    }
    
    this.originalData = Object.assign({},this.vehicleData);
    if (environment.country == 'SA') {
      this.showGPSProvider = true;
      this.vehicleData.gps_provider = this.parentData.gps.provider;
      this.vehicleData.gps_id = this.parentData.gps.id;
    }else{
      this.vehicleData.gps_provider = this.parentData.gps.provider;
    }
    //prepopulate the vehicle data
    this.selectVehicleType(this.parentData.vehicle);
    this.minYear = this.d.getFullYear() - 15;
  }

  getGPSProviders(){
    this.http.get('constants/carrier', '', 3).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {

          if (data.data.gps.length) {
            this.gps_providers = data.data.gps;
            //pre populate the gps provider if present
            if(environment.country == 'SA' && this.vehicleData.gps_provider && this.vehicleData.gps_id){
              let selected_gps_provider = this.gps_providers.filter((element)=>{
                if(element.value == this.vehicleData.gps_provider){
                  return element;
                }
              });
              this.selectedGPSProvider = selected_gps_provider[0];
            }else if (environment.country == 'IN' && this.vehicleData.gps_provider){
              let selected_gps_provider = this.gps_providers.filter((element)=>{
                if(element.value == this.vehicleData.gps_provider){
                  return element;
                }
              });
              this.selectedGPSProvider = selected_gps_provider[0];
            }
            if(this.selectedGPSProvider){
              this.selectGPSProvider(this.selectedGPSProvider);
            }
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  openVerifyModal(url) {
    window.open(url, '_blank');
  }

  fileChanged(event: any) {
    this.formData.append('vehiclePic', event.target.files[0], event.target.files[0].name);
  }

  submit() {
    if (!this.validate()) {
      return;
    }

    if(!this.vehicleData.gps_provider){
      delete this.vehicleData.gps_provider
    }
    
    this.http.update('v2/vehicle/'+this.parentData._id, this.vehicleData).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.snackbar.openSnackBar(this.messages.VEHICLES.EDIT_VEHICLE.SUCCESS.EDIT);
          this.closeDialog(data);
        }
      },
      (err: any) => {
        console.log('Err::', err);
        this.snackbar.openSnackBar(err.error.message,'','err')
        this.formData = new FormData();
      }
    );

  }

  closeDialog(data = '') {
    this.dialog.close(data);
  }

  selectVehicleType(type) {
    this.vehicleData.type = type._id;
    this.type = type.name;
  }

  getVehicleTypes() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {

          if (data.data.vehicle_types.length) {
            this.vehicletypes = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  // populate assets when provider is selected
  selectGPSProvider(provider) {
    if(environment.country == 'SA'){
      this.selectedGPSProvider = provider;
      this.vehicleData.gps_provider = provider.value;
      this.selectedAsset = '';
      this.assets = [];
      this.assetsArray = [];
      this.getAssets(provider);
    }else{
      this.selectedGPSProvider = provider;
      this.vehicleData.gps_provider = provider.value;
    }
  }

  //get assets of the given provider
   getAssets(provider){
    this.spinner = true;

     this.http.get('ksa_gps/assets', {provider: provider.value},3).subscribe(
      (data: any) => {
        this.spinner = false;

        this.assetsArray = data.data;
        this.assets = data.data;
        if(this.vehicleData.gps_id){
          let asset_= this.assets.filter((e)=>{
            if(e.asset_id == this.vehicleData.gps_id){
              return e;
            }
          });
          this.selectAsset(asset_[0]);
        }
      },
      (err)=>{
        this.spinner = false;
        this.snackbar.openSnackBar(err.error.message,'','err');
      });
  }

  selectAsset(asset) {    
    this.selectedAsset = asset.reg_number;
    this.vehicleData.gps_id = asset.asset_id;
  }

  applyFilter(value: string) {
    if (value) {
      this.assets = this.assets.filter(option => option.reg_number.includes(value));
    } else {
      this.vehicleData.gps_id = '';
      this.assets = this.assetsArray;
    }
  }

  validate() {
    let valid = false;
    if (!this.vehicleData.registrationNumber) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.ADD_VEHICLE.VALIDATION.REGISTRATION_NUMBER_EMPTY'), '', 'err');
    } else if (environment.country == 'IN' && !this.validData.isVehicle(this.vehicleData.registrationNumber)) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.EDIT_VEHICLE.VALIDATION.REGISTRATION_NUMBER'), '', 'err');
    } else if  ((environment.country == 'SA' || environment.country == 'BR') && !this.validData.isKsaVehicle(this.vehicleData.registrationNumber)) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.EDIT_VEHICLE.VALIDATION.REGISTRATION_NUMBER'), '', 'err');
    }  else if (!this.vehicleData.type) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.ADD_VEHICLE.VALIDATION.VEHICLE_TYPE'), '', 'err');
    } else {
      valid = true;
      const keys = Object.keys(this.vehicleData);
      keys.forEach((key) => {
        if (!this.vehicleData[key]) {
          delete this.vehicleData[key];
        }
      });
    }
    return valid;
  }
}
